import React from 'react'
import ReactDOM from 'react-dom'
import store from 'modules'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import { AdminExtensionProvider } from 'context/AdminExtensionContext'
import { Theme } from '@shopline/dashboard-ui'
import { QueryClient, QueryClientProvider } from 'react-query'
import reportWebVitals from './reportWebVitals'
import App from './App'

import './i18n'
import './index.css'

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={Theme}>
      <AdminExtensionProvider>
        <QueryClientProvider
          client={
            new QueryClient({
              defaultOptions: {
                queries: {
                  refetchIntervalInBackground: false,
                  refetchOnWindowFocus: false,
                  refetchOnReconnect: false,
                },
              },
            })
          }
        >
          <Provider store={store}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </Provider>
        </QueryClientProvider>
      </AdminExtensionProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)

reportWebVitals()
